/* カート内モーダル */
$(".cart-slider-03 span").on("click", function () {
    $(this).toggleClass("active");
    $(".splide-processing-03").toggleClass("active");
    $(".modal-bg-black-03").toggleClass("active");
    $("body").toggleClass("fixed");
});

$(".modal-bg-black-03").on("click", function () {
    $(this).toggleClass("active");
    $(".splide-processing-03").toggleClass("active");
    $(".cart-slider-03 span").toggleClass("active");
    $("body").toggleClass("fixed");
});

$(".splide-processing-03 .close-btn__wrap img").on("click", function () {
    $(".modal-bg-black-03").toggleClass("active");
    $(".splide-processing-03").toggleClass("active");
    $(".cart-slider-03 span").toggleClass("active");
    $("body").toggleClass("fixed");
});

$(".splide-processing-btn-03 .complete").on("click", function () {
    $(".modal-bg-black-03").toggleClass("active");
    $(".splide-processing-03").toggleClass("active");
    $(".cart-slider-03 span").toggleClass("active");
    $("body").toggleClass("fixed");
});

/* スライダー矢印の制御 */
function backbtn03() {
    $(".splide-processing-03 .splide__arrow--prev").click();
}

function nextbtn03() {
    $(".splide-processing-03 .splide__arrow--next").click();
}

/* 1スライド目 入力チェック */
$(document).ready(function () {
    $('input[name="裾上げについて注意事項の同意"]').change(function () {
        if ($('input[name="裾上げについて注意事項の同意"]:checked').length > 0) {
            $(".splide-processing-03 .next.check01").removeClass("disabled");
        } else {
            $(".splide-processing-03 .next.check01").addClass("disabled");
        }
    });
});

/* 裾上げ商品 個別入力 */

/* -------------------- */
/* ------ 1商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-01").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-01");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】1商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input01");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput01() {
    const inputField = document.getElementById("p3-target-input01");
    const targetInput = document.getElementById("p3-step05-personal-check-01");
    const textErrorMessage = document.getElementById("p3-product-empty-01");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】1商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-01 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input01").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-01 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput01();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange01() {
    const inputField = document.getElementById("p3-target-input01");
    const targetInput = document.getElementById("p3-step05-personal-check-01");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】1商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-01 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】1商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange01);
});

/* -------------------- */
/* ------ 2商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-02").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-02");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】2商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input02");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput02() {
    const inputField = document.getElementById("p3-target-input02");
    const targetInput = document.getElementById("p3-step05-personal-check-02");
    const textErrorMessage = document.getElementById("p3-product-empty-02");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】2商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-02 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input02").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-02 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput02();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange02() {
    const inputField = document.getElementById("p3-target-input02");
    const targetInput = document.getElementById("p3-step05-personal-check-02");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】2商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-02 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】2商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange02);
});

/* -------------------- */
/* ------ 3商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-03").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-03");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】3商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input03");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput03() {
    const inputField = document.getElementById("p3-target-input03");
    const targetInput = document.getElementById("p3-step05-personal-check-03");
    const textErrorMessage = document.getElementById("p3-product-empty-03");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】3商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-03 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input03").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-03 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput03();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange03() {
    const inputField = document.getElementById("p3-target-input03");
    const targetInput = document.getElementById("p3-step05-personal-check-03");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】3商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-03 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】3商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange03);
});

/* -------------------- */
/* ------ 4商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-04").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-04");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】4商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input04");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput04() {
    const inputField = document.getElementById("p3-target-input04");
    const targetInput = document.getElementById("p3-step05-personal-check-04");
    const textErrorMessage = document.getElementById("p3-product-empty-04");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】4商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-04 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input04").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-04 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput04();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange04() {
    const inputField = document.getElementById("p3-target-input04");
    const targetInput = document.getElementById("p3-step05-personal-check-04");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】4商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-04 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】4商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange04);
});

/* -------------------- */
/* ------ 5商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-05").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-05");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】5商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input05");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput05() {
    const inputField = document.getElementById("p3-target-input05");
    const targetInput = document.getElementById("p3-step05-personal-check-05");
    const textErrorMessage = document.getElementById("p3-product-empty-05");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】5商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-05 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input05").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-05 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput05();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange05() {
    const inputField = document.getElementById("p3-target-input05");
    const targetInput = document.getElementById("p3-step05-personal-check-05");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】5商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-05 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】5商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange05);
});

/* -------------------- */
/* ------ 6商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-06").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-06");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】6商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input06");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput06() {
    const inputField = document.getElementById("p3-target-input06");
    const targetInput = document.getElementById("p3-step05-personal-check-06");
    const textErrorMessage = document.getElementById("p3-product-empty-06");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】6商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-06 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input06").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-06 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput06();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange06() {
    const inputField = document.getElementById("p3-target-input06");
    const targetInput = document.getElementById("p3-step05-personal-check-06");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】6商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-06 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】6商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange06);
});

/* -------------------- */
/* ------ 7商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-07").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-07");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】7商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input07");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput07() {
    const inputField = document.getElementById("p3-target-input07");
    const targetInput = document.getElementById("p3-step05-personal-check-07");
    const textErrorMessage = document.getElementById("p3-product-empty-07");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】7商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-07 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input07").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-07 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput07();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange07() {
    const inputField = document.getElementById("p3-target-input07");
    const targetInput = document.getElementById("p3-step05-personal-check-07");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】7商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-07 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】7商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange07);
});

/* -------------------- */
/* ------ 8商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-08").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-08");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】8商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input08");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput08() {
    const inputField = document.getElementById("p3-target-input08");
    const targetInput = document.getElementById("p3-step05-personal-check-08");
    const textErrorMessage = document.getElementById("p3-product-empty-08");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】8商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-08 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input08").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-08 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput08();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange08() {
    const inputField = document.getElementById("p3-target-input08");
    const targetInput = document.getElementById("p3-step05-personal-check-08");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】8商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-08 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】8商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange08);
});

/* -------------------- */
/* ------ 9商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-09").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-09");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】9商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input09");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput09() {
    const inputField = document.getElementById("p3-target-input09");
    const targetInput = document.getElementById("p3-step05-personal-check-09");
    const textErrorMessage = document.getElementById("p3-product-empty-09");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】9商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-09 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input09").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-09 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput09();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange09() {
    const inputField = document.getElementById("p3-target-input09");
    const targetInput = document.getElementById("p3-step05-personal-check-09");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】9商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-09 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】9商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange09);
});

/* -------------------- */
/* ------ 10商品目 ------ */
/* -------------------- */
document.getElementById("p3-step05-personal-check-10").addEventListener("input", function (e) {
    const inputField = this;
    const textErrorMessage = document.getElementById("p3-step05-personal-error-empty-10");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】10商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const targetInput = document.getElementById("p3-target-input10");
    const isEmpty = inputField.value.length === 0;
    const isTargetInputEmpty = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
    }

    if (isTargetInputEmpty) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
    }

    if (!isEmpty && !isTargetInputEmpty && isRadioChecked) {
        nextButton.classList.remove("disabled");
    }
});

/* 商品情報のバリデーションチェック */
function p3_validateEnTargetInput10() {
    const inputField = document.getElementById("p3-target-input10");
    const targetInput = document.getElementById("p3-step05-personal-check-10");
    const textErrorMessage = document.getElementById("p3-product-empty-10");
    const radioButtons = document.querySelectorAll("input[name='attributes[【裾上げ】10商品目：縫い方]']");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;
    const isRadioChecked = Array.from(radioButtons).some((radio) => radio.checked);

    if (isEmpty) {
        inputField.classList.add("error_03");
        textErrorMessage.style.display = "inline-block";
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_03");
        textErrorMessage.style.display = "none";
        nextButton.classList.remove("disabled");
    }

    if (isEmpty02) {
        inputField.classList.add("error_04");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_04");
        nextButton.classList.remove("disabled");
    }

    if (!isRadioChecked) {
        inputField.classList.add("error_05");
        nextButton.classList.add("disabled");
    } else {
        inputField.classList.remove("error_05");
        nextButton.classList.remove("disabled");
    }
}

$("#p3-item-10 .copy-btn").click(function () {
    var itemWrap01 = $(this).closest(".cart-item__wrap");
    var productName01 = itemWrap01.find("h2").text();

    // バリエーション情報を取得
    var options01 = itemWrap01
        .find("ul li")
        .map(function () {
            return $(this).text();
        })
        .get()
        .join(", ");

    // 入力フィールドに商品名とバリエーション情報を入力
    $("#p3-target-input10").val(productName01 + " (" + options01 + ")");

    // 最終確認画面へ出力
    $(".p3-step05-personal-10 .product").text(productName01 + " (" + options01 + ")");

    // バリデーションチェックを実行
    p3_validateEnTargetInput10();
});

/* ラジオボタン変更時のチェック */
function handleRadioChange10() {
    const inputField = document.getElementById("p3-target-input10");
    const targetInput = document.getElementById("p3-step05-personal-check-10");
    const nextButton = document.querySelector(".splide-processing-btn-03 span.next");

    const isEmpty = inputField.value.length === 0;
    const isEmpty02 = targetInput.value.length === 0;

    if (isEmpty || isEmpty02) {
        nextButton.classList.add("disabled");
    } else {
        nextButton.classList.remove("disabled");
    }

    // ラジオボタンの値を出力
    const selectedRadio = document.querySelector("input[name='attributes[【裾上げ】10商品目：縫い方]']:checked");
    if (selectedRadio) {
        const outputElement = document.querySelector(".p3-step05-personal-10 .nuikata");
        outputElement.textContent = selectedRadio.value;
    }
}

document.querySelectorAll("input[name='attributes[【裾上げ】10商品目：縫い方]']").forEach((radio) => {
    radio.addEventListener("change", handleRadioChange10);
});

/* ---- 商品バリデーションここまで ----*/

/* 刺繍結果表示 */
$('input[name="attributes[【裾上げ】1商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】1商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-01").css("display", "table-cell");
    $(".p3-step05-personal-01").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-01 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】2商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】2商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-02").css("display", "table-cell");
    $(".p3-step05-personal-02").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-02 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】3商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】3商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-03").css("display", "table-cell");
    $(".p3-step05-personal-03").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-03 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】4商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】4商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-04").css("display", "table-cell");
    $(".p3-step05-personal-04").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-04 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】5商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】5商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-05").css("display", "table-cell");
    $(".p3-step05-personal-05").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-05 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】6商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】6商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-06").css("display", "table-cell");
    $(".p3-step05-personal-06").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-06 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】7商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】7商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-07").css("display", "table-cell");
    $(".p3-step05-personal-07").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-07 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】8商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】8商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-08").css("display", "table-cell");
    $(".p3-step05-personal-08").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-08 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】9商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】9商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-09").css("display", "table-cell");
    $(".p3-step05-personal-09").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-09 .main").text(mainName);
});

$('input[name="attributes[【裾上げ】10商品目：サイズ]"]').on("input", function () {
    var mainName = $('input[name="attributes[【裾上げ】10商品目：サイズ]"]').val();

    // 最終入力確認にも出力 & 該当するテーブルを表示
    $(".p3-step05-personal-10").css("display", "table-cell");
    $(".p3-step05-personal-10").prev("th").css("display", "table-cell");
    $(".p3-step05-personal-10 .main").text(mainName);
});

/* 入力欄の追加 */
$(document).ready(function () {
    let currentIndex = 1;

    $(".splide-processing-03 .add-con-btn__wrap").on("click", function () {
        currentIndex++;
        let nextElement = $(
            ".splide-processing-03 .individual__wrap.btn01.num" + currentIndex.toString().padStart(2, "0")
        );

        if (nextElement.length) {
            nextElement.show();
        }

        const nextButton = document.querySelector(".splide-processing-btn-03 span.next");
        nextButton.classList.add("disabled");
    });
});
